import ScoreRangeRewardCalculationTypeEditor from "../../../pages/actionModules/ActionModuleEditor/RewardCalculationEditor/ScoreRangeRewardCalculationTypeEditor";
import { RewardCalculationTypeDefinition } from "../actionModule";
import { BaseRewardCalculationType, isBaseRewardCalculationTypeModel, RewardCalculationType, ScoreRange } from "./rewardCalculationType";

export interface ScoreRangeRewardCalculationTypeModel extends BaseRewardCalculationType {
    scoreRanges: ScoreRange[]
};

export function isScoreRangeRewardCalculationTypeModel(value: unknown): value is ScoreRangeRewardCalculationTypeModel {
    return (
        isBaseRewardCalculationTypeModel(value) &&
        value.type === RewardCalculationType.ScoreRangeCalculationType &&
        "scoreRanges" in value &&
        Array.isArray((value as ScoreRangeRewardCalculationTypeModel).scoreRanges)
    );
}

export const ScoreRangeRewardCalculationType: RewardCalculationTypeDefinition = {
    name: "actionModules.rewardCalculationType.scoreRange.name",
    defaultValue: {
        scoreRanges: [
            { scoreFrom: 0, scoreTo: 5, pointsRewarded: 5 },
            { scoreFrom: 5, scoreTo: 10, pointsRewarded: 4 },
            { scoreFrom: 10, scoreTo: 15, pointsRewarded: 3 },
            { scoreFrom: 15, scoreTo: 20, pointsRewarded: 2 },
            { scoreFrom: 20, scoreTo: 25, pointsRewarded: 1 },
            { scoreFrom: 25, scoreTo: 30, pointsRewarded: 0 },
        ],
    } as ScoreRangeRewardCalculationTypeModel,
    type: RewardCalculationType.ScoreRangeCalculationType,
    editor: (props) => <ScoreRangeRewardCalculationTypeEditor {...props} />
};